<template>
    <div class="flex flex-no-wrap flex-auto">
        <input class="form-control" :class="[inputClass, {'rounded-r-none': clearable && !disabled}]"
               :id="id"
               :type="type"
               v-model="model"
               :placeholder="!disabled ? placeholder : ''"
               :disabled="disabled"
               ref="input">
        <vue-button icon="close"
                    icon-class="svg-md"
                    :class="btnClass"
                    type="button"
                    class="btn btn-primary btn-outline text-gray rounded-l-none border-l-0 flex-no-shrink"
                    @click="clear"
                    v-if="clearable && !disabled"/>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      default: null,
    },

    placeholder: {
      type: String,
      default: null,
    },

    type: {
      type: String,
      default: 'text',
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    inputClass: {
      type: String,
      default: null,
    },

    btnClass: {
      type: String,
      default: null,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    clear() {
      this.model = '';
      this.$refs.input.focus();
    },
  },
};
</script>